module.exports = __webpack_public_path__ + "static/media/README.b0d816ef.md";